import { EnqueueSnackbarLazyType } from 'components/banners/useLazySnackbar';
import { approveAction as captainApproveAction } from 'components/inbox/bookingPanel/SidebarCaptainActions';
import { approveAction as ownerApproveAction } from 'components/inbox/bookingPanel/SidebarOwnerActions';

// eslint-disable-next-line import/prefer-default-export
export const approveDeclineBookingActions = (
  booking,
  router,
  enqueueSnackbar: EnqueueSnackbarLazyType,
  handleOpenOwnerBookingActionsModal: (actionType: 'approve' | 'decline') => void,
  handleOpenCaptainActionModal: (actionType: 'approve' | 'decline') => void,
  openMultibookModal: () => void
) => {
  const userType = booking?.user_type;
  if (userType === 'owner') {
    return {
      approve: ownerApproveAction(
        booking,
        router,
        enqueueSnackbar,
        () => handleOpenOwnerBookingActionsModal('approve'),
        openMultibookModal
      ).onClick,
      decline: () => {
        if (booking.can_decline) {
          handleOpenOwnerBookingActionsModal('decline');
        } else if (booking.cancel || booking.can_modify) {
          router.push(`/bookings/${booking.id}/edit`);
        }
      },
    };
  }
  return {
    approve: captainApproveAction(booking, () => handleOpenCaptainActionModal('approve')).onClick,
    decline: () => {
      if (booking.can_captain_decline && !booking.captain_declined) {
        handleOpenCaptainActionModal('decline');
      }
    },
  };
};
